export const DESKTOP = 'desktop';
export const MOBILE = 'mobile';
export const TABLET = 'tablet';

export type DEVICE_TYPES = typeof DESKTOP | typeof MOBILE | typeof TABLET;
